function G3() {
    return (
        <main className='main'>
            <h2>Опис трудових функцій; професійні компетентності; знання, уміння та навички</h2>
            <table>
                <tr>
                    <td colSpan="3">
                        ҐЗ Нормативно-правова
                    </td>
                </tr>
                <tr className='bold'>
                    <td>Професійні компетентності (за трудовою дією або групою трудових дій)</td>
                    <td>Знання</td>
                    <td>Уміння та навички</td>
                </tr>
                <tr>
                    <td rowSpan="3">
                        Ґ3.1 Здатність керуватися в управлінській діяльності законодавством України
                    </td>
                    <td>
                        Ґ3.1.31 Закони України і нормативно-правові акти у галузі освіти
                    </td>
                    <td>
                        Ґ3.1.У1 Здійснювати управлінську діяльність згідно з вимогами законодавчої і нормативно-правової бази України
                    </td>
                </tr>
                <tr>
                    <td>
                        Ґ3.1.32 Знання особливостей державної, регіональної та місцевої системи управління дошкільної освітою
                    </td>
                    <td>
                        Ґ3.1.У2 Здійснювати стратегічний розвиток закладу дошкільної освіти відповідно до особливостей освітньої політики
                    </td>
                </tr>
                <tr>
                    <td>
                        Ґ3.1.33 Повноваження засновника та керівника закладу дошкільної освіти, органів управління у сфері освіти
                    </td>
                    <td>
                        Ґ3.1.УЗ Здійснювати свою професійну діяльність в межах компетенції
                    </td>
                </tr>
                <tr>
                    <td rowSpan="2">
                        ҐЗ.2 Здатність до документування управлінської діяльності
                    </td>
                    <td>
                        Ґ3.2.31 Загальні вимоги щодо документування управлінської інформації та організації роботи з документами у закладах дошкільної освіти
                    </td>
                    <td>
                        Ґ3.2.У1 Розробляти, вести та зберігати діловодну документацію
                    </td>
                </tr>
                <tr>
                    <td>
                        Ґ3.2.32 Системи електронного документообігу в закладі дошкільної освіти
                    </td>
                    <td>
                        Ґ3.2.У2 Використовувати системи електронного документообігу в закладі дошкільної освіти
                    </td>
                </tr>
                <tr>
                    <td rowSpan="3">
                        ҐЗ.З Здатність забезпечувати дотримання академічної доброчесності учасниками освітнього процесу
                    </td>
                    <td>
                        ҐЗ.З.31 Сутність поняття, види, дотримання та порушення академічної доброчесності
                    </td>
                    <td>
                        ҐЗ.З.У1 Впроваджувати принципи академічної доброчесності під час освітнього процесу
                    </td>
                </tr>
                <tr>
                    <td>
                        Ґ3.3.32 Нормативно-правові вимоги щодо дотримання академічної доброчесності педагогічними працівниками
                    </td>
                    <td>
                        ҐЗ.З.У2 Дотримуватись нормативно-правових норм академічної доброчесності під час професійної діяльності
                    </td>
                </tr>
                <tr>
                    <td>
                        ҐЗ.З.ЗЗ Академічна відповідальність за порушення, порядок виявлення та встановлення фактів порушення академічної доброчесності
                    </td>
                    <td>
                        ҐЗ.З.УЗ Здійснювати систематичний контроль щодо дотримання академічної доброчесності педагогічними працівниками
                    </td>
                </tr>
                <tr>
                    <td rowspan="2">
                        Ґ3.4 Здатність здійснювати професійну діяльність державною мовою
                    </td>
                    <td>
                        Ґ3.4.31 Норми та стилі літературної української мови
                    </td>
                    <td>
                        Ґ3.4.У1 Висловлювати власні думки в усній та письмовій формах державною мовою
                    </td>
                </tr>
                <tr>
                    <td>
                        Ґ3.4.32 Основи усного й писемного спілкування в офіційно-діловій сфері України
                    </td>
                    <td>
                        Ґ3.4.У2 Використовувати діловий стиль спілкування у професійній діяльності
                    </td>
                </tr>
            </table>
        </main>
    )
}

export {G3}